import { LazyLoadImage } from "react-lazy-load-image-component";

function ProjectList({ projects, setActiveProject }) {
    const widthThumbnail = 400;
    const heightThumbnail = 300;
    function openInNewTab(url) {
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    }

    function handleClick(project) {
        if (project.selfHosted) {
            setActiveProject(project.title);
        } else {
            openInNewTab(project.url);
        }
    }
    return (
        <div className="project-list ">
            {projects.map((project) => {
                return (
                    <div key={project.title} className="project-line">
                        <h2
                            onClick={() => handleClick(project)}
                            className="project-title underline-variable"
                        >
                            {project.title}
                        </h2>
                        <LazyLoadImage
                            src={project.thumbnail}
                            width={`${
                                project.hasPortraitThumbnail
                                    ? "300"
                                    : widthThumbnail
                            }px`}
                            height={`${
                                project.hasPortraitThumbnail
                                    ? "350"
                                    : heightThumbnail
                            }px`}
                            effect="blur"
                            className="project-line-img"
                            aria-hidden
                        />
                    </div>
                );
            })}
        </div>
    );
}

export default ProjectList;
